<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M5.8 13.9a1 1 0 0 1-.78-1.62l3.81-4.72a1.5 1.5 0 0 1 2.34 0l3.81 4.72a1 1 0 0 1-.78 1.63H5.8Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M5.02 12.28a1 1 0 0 0 .78 1.63h8.4a1 1 0 0 0 .78-1.63l-3.81-4.72a1.5 1.5 0 0 0-2.34 0l-3.81 4.72Zm9.18.63H5.8L9.6 8.19a.5.5 0 0 1 .78 0l3.81 4.72Z"
    />
  </svg>
</template>
